import React from 'react'
import './brand.css'

const Brand = () => {
  return (
    <div>
      
    </div>
  )
}

export default Brand
